<template>
  <svg
    class="logo"
    :height="height"
    viewBox="0 0 900 140"
    role="img"
    aria-label="Data Platform Portal"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="textGradient" gradientUnits="userSpaceOnUse" x1="0" x2="900" y1="0" y2="0">
        <stop :stop-color="colorsComputed.end" />
        <stop :stop-color="colorsComputed.start" offset="1" />
      </linearGradient>
    </defs>

    <!-- Data Platform -->
    <text
      x="320"
      y="72"
      text-anchor="middle"
      dominant-baseline="middle"
      font-size="90"
      font-weight="900"
      fill="url(#textGradient)"
    >
      Data Platform
    </text>

    <!-- PORTAL -->
    <text
      x="640"
      y="64"
      dominant-baseline="middle"
      font-size="36"
      font-weight="900"
      letter-spacing="3"
      fill="url(#textGradient)"
    >
      PORTAL
    </text>
  </svg>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'

const { getColor } = useColors()

const props = withDefaults(
  defineProps<{
    height?: number
    start?: string
    end?: string
  }>(),
  {
    height: 60,
    start: 'primary',
    end: undefined,
  },
)

const colorsComputed = computed(() => ({
  start: getColor(props.start),
  end: getColor(props.end || props.start),
}))
</script>

<style scoped>
.logo {
  width: 80%;
  max-width: 620px;
  height: auto;
}
</style>
